import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Chart from 'react-apexcharts'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { Card } from 'components/Library'
import { colors } from 'components/Library/theme'
import { CANTIDAD_MESES_GRAFICO } from 'utils/constants'

dayjs.extend(customParseFormat)
const NewUsers = () => {
  const { globalAnalytics } = useSelector((state) => state.analytics)
  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    if (globalAnalytics[3] && globalAnalytics[3].rowCount > 0) {
      // Armar arreglo últimos 6 meses
      const ultimosMeses = []
      const fechaTemporal = new Date()
      for (let i = 0; i < CANTIDAD_MESES_GRAFICO; i++) {
        const mesFormateado = dayjs(fechaTemporal).format('MMM YYYY') // Formatear mes de la iteración actual
        ultimosMeses.unshift({ mes: mesFormateado, valor: 0 }) // Añadir mes al principio del arreglo
        fechaTemporal.setMonth(fechaTemporal.getMonth() - 1) // Restar 1 mes
      }

      globalAnalytics[4].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual y formatearlos
        const anioMes = analytic.dimensionValues[0].value // yearMonth
        const mesFormateado = dayjs(anioMes, 'YYYYMM').format('MMM YYYY')
        const valor = analytic.metricValues[0].value // newUsers

        // Encontrar el index de ultimosMeses igual al mesFormateado para asignar el valor
        const index = ultimosMeses.findIndex((item) => item.mes === mesFormateado)
        if (index !== -1) ultimosMeses[index].valor = +valor
      })

      setDatosGrafico(ultimosMeses)
    }
  }, [globalAnalytics])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Chart
        style={{ width: '100%' }}
        options={{
          chart: {
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              distributed: true
            }
          },
          stroke: {
            curve: 'straight'
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: datosGrafico.map((item) => item.mes)
          },
          title: {
            text: 'Nuevos usuarios por mes'
          },
          colors: [colors.primary, colors.secondary, colors.tertiary],
          tooltip: {
            y: {
              formatter: parseInt
            }
          }
        }}
        height={250}
        series={[
          {
            name: 'Nuevos usuarios',
            data: datosGrafico.map((item) => item.valor)
          }
        ]}
        type="area"
      />
    </Card>
  )
}

export default NewUsers
